import {useTranslation} from 'react-i18next';
import {CareTaskFeature} from '../../../backend/enums/care-task-feature';
import {ChangeHistoryValues} from '../../../backend/interfaces/care-task';
import {translations} from '../../../i18n/translations';
import {BaseLogAction} from '../common/base-log-action';
import {TaskLogChangeField} from './task-log-change-field';

/**
 * This component renders a task log for a `partial-update` action.
 *
 * @example
 * ```txt
 * John Doe editou a tarefa                  2025/01/01 às 14:00:00
 * Estado: Realizada
 * Notas: Lorem ipsum dolor sit amet.
 * Temperatura: 36.5 ºC
 * ```
 */
export function TaskLogPartialUpdateAction({
  changes,
  feature,
  name,
  picture,
  date,
  compactDisplay = false,
  ...rest
}: {
  changes?: ChangeHistoryValues[];
  feature?: CareTaskFeature;
  name: string;
  picture?: string;
  date?: string;
  compactDisplay?: boolean;
  key?: string;
}) {
  const {t} = useTranslation();

  return (
    <BaseLogAction
      title={name + ' ' + t(translations.care_and_activities.handle_task_modal.history.update)}
      name={name}
      picture={picture}
      date={date}
      compactDisplay={compactDisplay}
      {...rest}
    >
      <div>
        {changes?.map((change, idx) => (
          <TaskLogChangeField key={idx + '_' + change.field} change={change} feature={feature} />
        ))}
      </div>
    </BaseLogAction>
  );
}
